import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../axiosBaseQuery";


const WellWaterBearingApi = createApi({
    reducerPath: "core/waterbearing/well",
    baseQuery: axiosBaseQuery,
    tagTypes: ["parameterWellWaterbearing"],
    endpoints: (builder) =>({
        parameterWellbearingFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['parameterWellWaterbearing'],
            query: (query = '') => ({
                url: "core/waterbearing/well" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        parameterWellbearingCreate: builder.mutation({
            invalidatesTags: ['parameterWellWaterbearing'],
            query: (data)=>({url: "core/waterbearing/well", method: "POST", data})
        }),
        parameterWellbearingUpdate: builder.mutation({
            invalidatesTags: ['parameterWellWaterbearing'],
            query: (data)=>({url: "/core/waterbearing/well/"+data.id, method: "PUT", data})
        }),
    
        parameterWellbearingDelete: builder.mutation({
            invalidatesTags: ['parameterWellWaterbearing'],
            query: (id)=>({url: "/core/waterbearing/well/"+id, method: "DELETE"})
        }),
    })
})

export const { useParameterWellbearingFindAllQuery, useParameterWellbearingCreateMutation, useParameterWellbearingUpdateMutation, useParameterWellbearingDeleteMutation } = WellWaterBearingApi;
export {WellWaterBearingApi};
